/**
 * Éligibilité d'un message aux actions staff « Déplacer vers Questions » et « Résoudre ».
 *
 * Seul un message de participant peut devenir une question. Un message envoyé quand le chat est en
 * mode Privé porte `privateMessage` sans destinataire : il reste éligible. Seule une réponse privée
 * adressée à un participant précis (avec `recipientAttendeeId`) est exclue, comme côté back.
 */

export type ChatQuestionEligibilityInput = {
  question?: boolean;
  questionHandled?: boolean;
  reaction?: boolean;
  /** Message de l'équipe (admin, présentateur, modérateur, invité). */
  staffAuthor?: boolean;
  privateMessage?: boolean;
  recipientAttendeeId?: number | null;
  repliedToMessageId?: number | null;
};

export function isAddressedPrivateReply({
  privateMessage,
  recipientAttendeeId,
}: Pick<ChatQuestionEligibilityInput, 'privateMessage' | 'recipientAttendeeId'>): boolean {
  return privateMessage === true && recipientAttendeeId != null;
}

function isAttendeeCandidate(input: ChatQuestionEligibilityInput): boolean {
  if (input.reaction === true) return false;
  if (input.staffAuthor === true) return false;
  return !isAddressedPrivateReply(input);
}

export function canMoveMessageToQuestions(input: ChatQuestionEligibilityInput): boolean {
  if (input.question === true) return false;
  return isAttendeeCandidate(input);
}

/** Résolution : uniquement sur la question d'origine, pas sur ses réponses. */
export function canResolveQuestion(input: ChatQuestionEligibilityInput): boolean {
  if (input.question !== true) return false;
  if (input.questionHandled === true) return false;
  if (input.repliedToMessageId != null) return false;
  return isAttendeeCandidate(input);
}
